<template>
  <v-container class="landing-page">
    <v-row justify="center" class="mb-8">
      <v-col cols="12" class="text-center">
        <h1 class="text-h3 mb-4">Dexis License Code Generator</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col v-for="tile in tiles" :key="tile.id" cols="12" sm="6" md="3" class="d-flex">
        <v-card
          :disabled="tile.disabled"
          :ripple="!tile.disabled"
          class="tile-card flex-grow-1"
          hover
          @click="navigateToPage(tile)"
        >
          <v-card-text class="text-center pa-6">
            <v-icon
              :icon="tile.icon"
              size="48"
              class="mb-4"
              :color="tile.disabled ? 'grey' : 'primary'"
            />
            <h3 class="text-h6 mb-2">{{ tile.title }}</h3>
            <p class="text-body-2 text-medium-emphasis">{{ tile.description }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type RouteLocationRaw, useRouter } from 'vue-router';

interface Tile {
  id: string;
  title: string;
  description: string;
  route: RouteLocationRaw;
  icon: string;
  disabled: boolean;
}

const router = useRouter();

const tiles = computed<Tile[]>(() => [
  {
    id: 'list-module-licenses',
    title: 'Module License',
    description: '',
    route: { name: 'module-license-list' },
    icon: 'mdi-key-outline',
    disabled: false,
  },
  {
    id: 'list-dexlib-licenses',
    title: 'DEXlib License',
    route: { name: 'dexlib-license-list'},
    icon: 'mdi-key',
    disabled: false,
  },
]);

const navigateToPage = (tile: Tile) => {
  if (!tile.disabled) {
    router.push(tile.route);
  }
};
</script>

<style lang="scss" scoped>
//.landing-page {
//  min-height: 80vh;
//  padding-top: 2rem;
//}
//
//.tile-card {
//  cursor: pointer;
//  transition: all 0.2s ease;
//
//  &:hover:not(.v-card--disabled) {
//    transform: translateY(-2px);
//  }
//}
</style>
